import { LanguageSchema } from "@/assets/lang";

const es: LanguageSchema = {
  "title": "Pulpo",
  "button": {
    "cancel": "Cancelar",
    "ok": "OK",
    "discardChanges": "Rechazar cambios",
    "search": "Consultar",
    "confirm": "Confirmar",
    "choose": "Seleccionar",
    "forward": "Siguiente",
    "back": "Atrás",
    "reset": "Volver",
    "apply": "Aplicar",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "send": "Enviar",
    "backToStart": "Volver al inicio",
    "backToLogin": "Volver al inicio de sesión",
    "no": "No",
    "yes": "Sí",
    "toPayment": "De pago",
    "finishOrder": "Realizar pedido",
    "thank": "Dar las gracias",
    "sendInvite": "Enviar invitación",
    "resend": "Reenviar",
    "startNow": "Empezar ahora",
    "skip": "Saltar",
    "register": "Regístrese ahora",
    "registerNoCode": "Registrarse sin código",
    "save": "Ahorra",
    "saveChanges": "Aplicar cambios",
    "delete": "{Eliminar",
    "addCart": "Añadir lista a la cesta",
    "orderNow": "Pedir ahora",
    "add": "Añadir a",
    "changePassword": "Cambiar contraseña",
    "changeLogin": "Cambiar datos de acceso",
    "changeEmail": "Cambiar correo electrónico",
    "edit": "Editar",
    "share": "Compartir",
    "delivererNotFound": "¿Proveedor no encontrado?",
    "joinLocation": "Únete al equipo",
    "createLocation": "Crear ubicación",
    "editSupplier": "Proveedor @.inferior:botón.editar",
    "create": "Crear",
    "deleteSupplier": "Borrar proveedor",
    "forwardApp": "Ir a la aplicación",
    "endIntro": "Terminar introducción",
    "upload": "Subir",
    "showMore": "ver más",
    "hide": "ocultar",
    "deleteAll": "Borrar todo",
    "settings": "Configuración",
    "manualSort": "Editar clasificación manual",
    "switchOldVersion": "A la versión antigua",
    "goToAppVersion": "Utilizar Octopus en el navegador",
    "updateList": "Añadir a la lista",
    "updateCart": "Añadir a la cesta",
    "openCameraScanner": "Escáner de cámara abierta",
    "orderOverview": "Ir al resumen de pedidos",
    "deleteSupplierCart": "Borrar la cesta de la compra",
    "resetAmount": "Restablecer cantidades de productos",
    "requestAiCall": "Solicitar llamada AI",
    "filter": {
      "all": "Todo",
      "promotion": "Acciones",
      "productSuggestion": "Inspiraciones"
    }
  },
  "input": {
    "text": "Texto",
    "password": "Contraseña",
    "email": "Correo electrónico",
    "number": "Número",
    "url": "Enlace",
    "tel": "Teléfono",
    "search": "Buscar en",
    "date": "Fecha",
    "orderDate": "Fecha de pedido",
    "datetime": "Fecha",
    "datetime-local": "Hora local",
    "month": "Mes",
    "week": "Semana",
    "time": "Hora",
    "range": "Escala",
    "color": "Color"
  },
  "table": {
    "empty": "La tabla no selecciona elementos"
  },
  "label": {
    "confirm": "confirmar",
    "pwConfirm": "@:entrada.contraseña @:etiqueta.confirmar",
    "newReminder": "Añadir nueva alarma de pedido",
    "selectPlaceholder": "Seleccionar",
    "orderHint": "Nota del proveedor",
    "selectTitle": "Seleccione",
    "date": "@:entrada.fecha",
    "time": "Hora",
    "dateTime": "@:etiqueta.fecha y @:etiqueta.hora",
    "sum": "Total",
    "orderDetails": "Detalles de la factura",
    "promoCode": "Código del cupón",
    "orderNumber": "Número de pedido",
    "octopusId": "Identificación del pulpo",
    "orderMessage": "Mensaje de pedido",
    "description": "Descripción",
    "sort": "Ordenar",
    "priceRange": "Rango de precios",
    "login": "Inicie sesión",
    "user": "Usuario",
    "newEmail": "Nuevo email",
    "oldPassword": "Antiguo @:input.password",
    "password": "@:entrada.contraseña",
    "pwForget": "@:input.password olvidado",
    "contactData": "Datos de contacto",
    "name": "Nombre",
    "list": "Lista",
    "type": "Tipo",
    "zip": "CÓDIGO POSTAL",
    "city": "Ciudad",
    "street": "Dirección",
    "streetNumber": "Número de casa",
    "phone": "Teléfono",
    "fax": "Fax",
    "streetName": "Nombre de la calle",
    "postalCode": "@:etiqueta.zip",
    "deliverer": "@:objeto.repartidor",
    "customerNumber": "Número de cliente/lugar de compra",
    "quickstart": "Código de inicio rápido",
    "email": "@:entrada.email",
    "firstName": "Nombre de pila",
    "lastName": "Nombre",
    "dark": "Oscuro",
    "light": "Claro",
    "standard": "Configuración del sistema",
    "amount": "Cantidad",
    "multipleAmount": "la cantidad debe ser múltiplo de {target}",
    "maxAmount": "Artículo máximo {target}",
    "standardList": "Lista estándar",
    "language": "Idioma",
    "aiCallLanguage": "Idioma de llamada",
    "oldMessages": "Noticias anteriores",
    "notification": {
      "allow": "Permitir mensajes"
    },
    "permission": {
      "order": "@:objeto.orden",
      "promotion": "@:objeto.promoción",
      "message": "@:objeto.mensaje",
      "news": "Noticias",
      "reminder": "Recordatorio de pedido",
      "productPromotion": "Sugerencias de productos",
      "sub": {
        "newOrder": "Nuevos pedidos",
        "updateStatus": "Actualización de pedidos",
        "added": "Nueva promoción",
        "ending": "Promoción en",
        "general": "General"
      },
      "mode": {
        "push": "Mensaje push",
        "email": "Notificación por correo electrónico",
        "popup": "Ventana emergente"
      }
    },
    "teamRole": {
      "admin": "Admin",
      "user": "Miembro del equipo Pro",
      "device": "Miembro del equipo base",
      "OWNER": "Propietario"
    },
    "teamRoleShort": {
      "admin": "Administrador",
      "user": "Profesional",
      "device": "Base",
      "OWNER": "Propietario"
    },
    "support": {
      "general": "Soporte Octopus",
      "gastro": "Equipo de Atención al Cliente Gastro",
      "technical": "Equipo Técnico de Atención al Cliente",
      "technicalLead": "Líder técnico",
      "distribution": "Firmante autorizado, marketing, ventas",
      "service": "Equipo de Atención al Cliente"
    },
    "loading": {
      "location": "Cargando @:objeto.ubicación"
    },
    "onAccount": "Factura",
    "onAccountOrCash": "Factura o efectivo",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "no especificado",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Bar / pub",
    "office": "Oficina",
    "coffeeShop": "Café / Bistro",
    "caterer": "Catering / cantina / clubes",
    "club": "Club / discoteca",
    "EVENT": "Evento",
    "DEALER": "Comerciante",
    "takeAway": "Cafetería / Quiosco / Comida para llevar",
    "canteen": "Cantina",
    "restaurant": "Restaurante",
    "hotel": "Hotel",
    "spaetshop": "Gasolinera / tienda nocturna",
    "getraenkehaendler": "Minorista de bebidas",
    "getraenkeabholmarkt": "Mercado de recogida de bebidas",
    "STAR_GASTRONOMY": "Gastronomía de estrellas",
    "SYSTEM_GASTRONOMY": "Sistema de catering",
    "spaetShop": "Tienda tardía",
    "impress": "Pie de imprenta",
    "termsOfUse": "Condiciones de uso",
    "agreeAGB1": "Estoy de acuerdo con",
    "agreeAGB2": "Política de privacidad",
    "agreeAGB3": "a",
    "category": "Categoría",
    "noCategory": "Sin categoría",
    "editTags": "Crear categorías propias",
    "selectDeliverer": "Seleccionar @:objeto.repartidor",
    "threeChars": "Introduzca al menos tres caracteres para obtener resultados de búsqueda",
    "offlineMode": "Modo sin conexión",
    "disable": "desactivar",
    "enable": "activar",
    "at": "en",
    "atTime": "en",
    "and": "y",
    "customerNo": "Número de cliente",
    "current": "Actual",
    "tags": "Filtrar categorías",
    "ownCategories": "Categorías propias",
    "supplierCategories": "Categorías de proveedores",
    "noFilter": "Sin filtro",
    "quantity": "Cantidad",
    "quantityBiggerZero": "Con cantidad",
    "or": "o",
    "delivererType": {
      "online": "En línea",
      "offline": "Fuera de línea"
    },
    "deleted": "Eliminado",
    "resetAmount": "Restablecer la cantidad de producto después de la orden",
    "compatibilityMode": "Modo de compatibilidad",
    "timeIssueDelivery": "La fecha de entrega que ha especificado ya ha pasado. Por favor, elija una fecha posterior.",
    "timeIssuePickup": "La hora de recogida que ha introducido ya ha pasado. Elija una fecha posterior.",
    "wait": "Por favor, espere",
    "day": "Etiqueta",
    "month": "Mes",
    "all": "Todos",
    "articleNo": "Nº de artículo",
    "targetStock": "Cantidad prevista",
    "targetStockShort": "Objetivo",
    "resetProductQuantity": "Al activar el control deslizante, la cantidad de productos se pone a cero tras la transmisión correcta de tu pedido. Si no lo activas, la cantidad de productos permanece precargada para el siguiente procesamiento de tu lista.",
    "offlineMode1": "El modo sin conexión te ofrece la posibilidad de sincronizar tu lista y gestionarla sin conexión a Internet.",
    "offlineMode2": "Al salir del modo sin conexión, todos los cambios se sincronizan con el servidor.",
    "darkMode": "Modo oscuro",
    "compatibilityText": {
      "activate": "Activa este modo si quieres editar las cantidades de productos de tu lista en la aplicación pero realizar el pedido a través del portal web.",
      "webPortal": "Mientras este modo esté activado, la cantidad de la lista se sincronizará con el portal web y no será posible realizar el pedido de esta lista a través de la app.",
      "deactivate": "Desactive este modo si desea realizar el pedido a través de la aplicación."
    },
    "newProductSuggestion": "Propuesta de nuevos productos",
    "files": "Archivos",
    "issue": "Problema",
    "place": "Localización",
    "expectation": "Expectativa",
    "steps": "Pasos",
    "availability": "Disponibilidad",
    "availableFrom": "Disponible en",
    "deletedLocations": "Ubicaciones eliminadas",
    "reducedListDesign": "Diseño de lista reducida",
    "reducedListDesignDescription": "El diseño de lista reducida cambia la vista de tu lista. Las imágenes de los productos están ocultas, pero se muestran botones adicionales para su manejo.",
    "insert": "insertar",
    "camera": "Escáner de cámara",
    "scanner": "Escáner",
    "picture": {
      "takePicture": "Haz una foto",
      "selectPicture": "Seleccionar foto",
      "editPicture": "Editar foto",
      "removePicture": "Eliminar imagen"
    },
    "uncategorized": "Sin categoría",
    "orderDataLoading": "Se cargan los datos del pedido.",
    "screenshot": "Captura de pantalla",
    "uploadImage": "Cargar imagen",
    "aiCallbackPhone": "Guardar número de teléfono para devolución de llamada",
    "chat": {
      "roomsEmpty": "Aún no hay conversaciones",
      "roomEmpty": "No se ha seleccionado ninguna conversación",
      "newMessages": "Mensajes nuevos",
      "messageDeleted": "Mensaje eliminado",
      "messagesEmpty": "Escribe tu primer mensaje",
      "conversationStarted": "Conversación iniciada:",
      "typeMessage": "Escribir mensaje…",
      "search": "Buscar"
    }
  },
  "error": {
    "addReminder": "No se ha podido asignar la alarma de pedido a una lista",
    "noMatch": "{target} no coincide",
    "notFound": "{target} no se encontró. | {target} no se encontró.",
    "invalid": "{target} no es correcto. | {target} no son correctos.",
    "empty": "{target} está vacío. | {target} están vacíos.",
    "noAuth": "{target} no tiene permiso. | {target} no tiene permiso.",
    "noAdmin": "No se ha encontrado ningún permiso de administrador.",
    "addCart": "No se ha podido añadir el producto a la cesta de la compra. | No se ha podido añadir el producto a la cesta de la compra.",
    "addPromoPackage": "El paquete promocional no se ha añadido a la cesta de la compra o sólo se ha añadido parcialmente.",
    "addList": "No se ha podido añadir el producto a la lista. | No se ha podido añadir el producto a la lista.",
    "create": "No se ha podido crear {target}. | No se ha podido crear {target}.",
    "order": "No se ha podido procesar el pedido.",
    "save": "No se ha podido guardar {target}.",
    "delete": "{target} no ha podido ser borrado.",
    "deleteUser": "No se ha podido eliminar el usuario.",
    "resendMail": "No se ha podido reenviar el correo electrónico.",
    "sendLink": "No se ha podido enviar el enlace.",
    "removeProduct": "No se ha podido eliminar el producto de la cesta de la compra. | No se ha podido eliminar el producto de la cesta de la compra.",
    "registerFalse": "Registro fallido.",
    "loginFalse": "Error al iniciar sesión.",
    "locationFalse": "Error en la creación de la ubicación.",
    "orderFinish": "No se ha podido crear el pedido.",
    "send": "No se ha podido enviar {target}.",
    "loadSupplier": "No se ha podido cargar el proveedor | No se han podido cargar los proveedores.",
    "loadLists": "No se han podido cargar las listas.",
    "load": "{target} no se ha podido cargar. | {target} no se pudo cargar.",
    "sendTicket": "No se ha podido enviar la respuesta.",
    "scanBarcode": "El código de barras escaneado no es válido.",
    "promotionLimitReached": "Máx. Cantidad de acción alcanzada",
    "aiCall": "@:error.returnType.Unknown",
    "ajv": {
      "required": "Los campos obligatorios no están rellenados",
      "format": "La entrada no es correcta: La entrada debe tener el formato {formatInfo}.",
      "formatInfo": {
        "date": "Fecha",
        "time": "Hora",
        "email": "Correo electrónico",
        "date-time": "Fecha y hora"
      },
      "oneOf": "La entrada no coincide con ninguno de los valores posibles",
      "minimum": "Entrada por debajo del mínimo de {min}",
      "maximum": "La entrada supera el máximo de {max}",
      "enum": "La entrada no contiene uno de los valores posibles"
    },
    "returnType": {
      "Unknown": "Se ha producido un error",
      "BadRequest": "La solicitud contiene datos incorrectos",
      "NotFound": "La solicitud no encontró un elemento.",
      "Unauthorized": "Falta autorización",
      "Forbidden": "Solicitud no autorizada",
      "NotImplemented": "Solicitud no implementada",
      "InvalidLogin": "Login inválido",
      "InvalidSession": "Sesión inválida",
      "InvalidPassword": "Contraseña inválida",
      "UserNotFound": "Usuario no encontrado",
      "UserAlreadyExists": "El usuario ya existe",
      "UserEmailAlreadyExists": "Ya existe un usuario con este email",
      "LocationNotFound": "Ubicación no encontrada",
      "CartItemNotFound": "Producto no encontrado",
      "ItemAlreadyInCart": "El producto ya está en la cesta de la compra, edita tu selección en la cesta",
      "ListAlreadyInCart": "La lista ya está en la cesta de la compra, edita tu selección en la cesta de la compra. La lista sólo se puede editar una vez que se ha ordenado en la cesta de la compra.",
      "ListCantBeDeleted": "No se puede borrar la lista.",
      "ListEmpty": "La lista está vacía. Compruebe si al menos un producto tiene una cantidad superior a 0.",
      "SupplierNotFound": "Proveedor no encontrado",
      "SupplierItemNotFound": "Producto del proveedor no encontrado",
      "OrderNotFound": "Pedido no encontrado",
      "ListNotFound": "Lista no encontrada",
      "ListItemNotFound": "Lista de productos no encontrada",
      "ItemAlreadyInList": "El producto ya está en la lista, edita tu selección en la lista",
      "ItemNotFromListSupplier": "El producto no es del proveedor de esta lista",
      "NotificationNotFound": "Notificación no encontrada",
      "TagNotFound": "Categoría no encontrada",
      "TagAlreadyExists": "La categoría ya existe",
      "UserNotInTeam": "Este usuario no está en el equipo",
      "TokenInvalid": "El código introducido no es válido",
      "ReminderNotFound": "No se ha encontrado el recordatorio de pedido",
      "OwnerCantBeEdited": "El propietario no puede editar",
      "PromoCodeInvalid": "El código del cupón no es válido",
      "PromoCodeInvalidAlreadyExists": "El código del cupón ya ha sido utilizado",
      "QuickStartCodeInvalid": "El código de inicio rápido no es válido",
      "SupplierAlreadyExists": "El proveedor ya existe",
      "SupplierCustomerInvalid": "La ubicación del proveedor no es válida",
      "LocationAlreadyExists": "La ubicación ya existe",
      "JavaApiInternalServerError": "Se ha producido un error",
      "NewsNotFound": "Mensaje no encontrado",
      "OrderMessageTooLong": "El mensaje de pedido supera la longitud máxima",
      "EmailInvalid": "El correo electrónico no es válido",
      "TokenInvalidAlreadyUsed": "El código introducido ya ha sido utilizado",
      "SupplierBlocked": "El proveedor está bloqueado",
      "PromotionExpired": "Artículos promocionales caducados"
    },
    "scannedProductNotAvailable": "El producto escaneado no está disponible en el catálogo de su proveedor, por lo que no puede añadirse a la lista del escáner.",
    "scannerNotAvailable": "No hay ningún escáner conectado a su dispositivo. Por favor, conéctese a un escáner o compruebe la conexión existente",
    "chat": {
      "loadMessages": "No se han podido cargar los mensajes",
      "sendMessage": "No se ha podido enviar el mensaje",
      "openRoom": "No se ha podido abrir el chat",
      "allowedMimeTypes": "Solo se admiten archivos JPG, PNG o PDF",
      "maxSize": "El archivo es demasiado grande (máx. {target} MB)",
      "maxFilesPerMessage": "Máximo {target} archivos por mensaje"
    }
  },
  "error.": "Se ha producido un error",
  "target": {
    "username": "Nombre de usuario",
    "user": "Usuario",
    "userAndPw": "@:target.username y @:input.password",
    "setting": "Configuración",
    "profile": "Perfil",
    "location": "Ubicación",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Producto | Productos",
    "request": "Solicitud",
    "list": "Lista",
    "required": "Campo obligatorio",
    "field": "Campo | Campos",
    "deliverer": "Proveedor | Proveedores",
    "tag": "Categoría | Categorías",
    "password": "Contraseña",
    "permission": "Autorización | Permisos"
  },
  "messages": {
    "orderFrom": "Pedido de",
    "mobileWeb": "Nos hemos dado cuenta de que estás intentando abrir la versión web de Pedidos Octopus desde un dispositivo móvil. Para una mejor experiencia de usuario, te recomendamos que en los dispositivos móviles descargues la aplicación móvil de tu tienda de aplicaciones y la utilices en lugar de la versión web.",
    "mobileWeb2": "Los siguientes enlaces le llevarán a la aplicación móvil Octopus Order:",
    "setting": {
      "location": "Edita tu ubicación",
      "profile": "Edita tu perfil de usuario",
      "delivererAssign": "Asigna un proveedor a tu ubicación",
      "delivererSelect": "Seleccionar proveedor",
      "inputCustomerNr": "Introducir número de cliente",
      "changeLocation": "Cambiar ubicación",
      "welcome1": "Hola {name}",
      "welcome2": "Aquí puedes elegir",
      "welcome3": "qué representación prefieres"
    },
    "emptyCart": "Lo sentimos, tu cesta de la compra está vacía.",
    "emptySuggestion": "Lo sentimos, no tenemos ninguna sugerencia de producto para ti en este momento.",
    "card": {
      "forwardPoints": "Haga clic aquí para ser redirigido a nuestro @:object.pointSystem",
      "points": "Puntos Octopus",
      "shop": "A la tienda Octopus",
      "currentPromotion": "Acciones en curso",
      "createLocationExplanation": "Un local puede ser un bar, un restaurante, un hotel, una oficina o un negocio similar.",
      "productSuggestion": "Novedades y sugerencias de productos"
    },
    "noPromotion": "Lo sentimos, no tenemos ninguna promoción para usted en este momento.",
    "promotion": {
      "order": "Pedidos en",
      "octopus": "Promociones Octopus",
      "deliverer": "Promociones de tus proveedores",
      "articles": "Estos artículos tienen un precio especial en este momento"
    },
    "home": {
      "createLocation": "Nuevo @:mensajes.localización.crear",
      "welcome1": "Hola {name}",
      "welcome2": "¿qué ubicación desea?",
      "image1": "Mezclado, pinchado, ¡ordenado!",
      "image2": "Seguro, digital, ¡pedido!",
      "image3": "Sencillo, rápido, ¡entrega!"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "Todos los artículos disponibles",
        "delivererCatalog": "Surtido del proveedor",
        "createProduct": "Añadir producto",
        "createdCustomProduct": "El producto ha sido añadido a la lista.",
        "noReducedSupplier": "Ninguno de tus proveedores ofrece promociones actualmente."
      },
      "home": {
        "orders": "Tus últimos pedidos",
        "favouriteList": "Sus últimos pedidos",
        "news": "Noticias Octopus"
      },
      "list": {
        "allLists": "Todas las listas de esta ubicación",
        "createList": "Nuevo @:titleRoute.addList",
        "noSupplier": "Aún no has añadido ningún proveedor a tu ubicación. Por favor, añade un proveedor a través de los ajustes."
      },
      "message": {
        "available": "Noticias disponibles"
      },
      "setting": {
        "order": "Todo sobre tus pedidos de un vistazo",
        "team": "Visión general y gestión de tu equipo",
        "deliverer": "Aquí puedes ver a tus proveedores",
        "notification": "Gestiona aquí tus notificaciones",
        "display": "Elige entre modo oscuro o claro",
        "statistic": "Aquí puedes ver tus evaluaciones",
        "imprint": "Información y legal",
        "support": "Contactar con Octopus Order",
        "orderNotificationTimer": "Configura las alarmas de tus pedidos",
        "intro": "Descubre todas las funciones de la app"
      }
    },
    "location": {
      "thank": "@:button.thank",
      "sendMsg": "Enviar mensaje",
      "create": "Añadir ubicación",
      "requestSent": "Su solicitud al proveedor {deliverer} está siendo revisada. Un representante se pondrá en contacto con usted en los próximos días.",
      "assignDeliverer": "Asigna un proveedor a tu ubicación",
      "welcome1": "Hola {name}",
      "intro": "En 4 breves pasos completamos juntos tu perfil"
    },
    "noOrders": "Aún no has realizado ningún pedido.",
    "noOrdersFilter": "No ha realizado ningún pedido en este periodo de tiempo.",
    "noLists": "Aún no has creado ninguna lista.",
    "noNotifications": "Aún no has recibido ninguna notificación.",
    "noNews": "Lo sentimos, actualmente no hay noticias de Octopus disponibles.",
    "order": {
      "deliveryType": "Seleccione el método de entrega",
      "deliveryTime": "Seleccione el día de entrega",
      "pickupTime": "Seleccionar hora de recogida",
      "pickup": "Recoger",
      "delivery": "Entrega",
      "overview": "Resumen de pedidos",
      "choosePayment": "Seleccionar forma de pago",
      "redirectPayment": "En el siguiente paso será redirigido a {target}.",
      "rememberPayment": "Utilice el método de pago para futuros pedidos.",
      "voucher": "Vale | Vales",
      "redeemVoucher": "@:mensajes.pedido.vale canjear",
      "voucherCode": "Introduzca el código del vale",
      "currentOrders": "Mis pedidos",
      "orderProducts": "Su pedido @:objeto.articulo",
      "otherProducts": "Otros artículos pedidos con frecuencia",
      "sent": "Su pedido ha sido transmitido con éxito a {target}.",
      "locationIssue": "Falta el lugar de recogida. Por favor, introduzca un lugar de recogida."
    },
    "deliverer": {
      "allDeliverers": "Todo @:objeto.repartidor desde {location}",
      "addDeliverer": "Añadir un @:object.deliverer",
      "noEmail": "Por favor, añada una dirección de correo electrónico al repartidor antes de realizar el pedido"
    },
    "team": {
      "invite": {
        "welcome1": "@:mensajes.inicio.bienvenido1",
        "welcome2": "Invita a otros empleados o socios a la app...",
        "copy": "O simplemente copia el código y compártelo:",
        "messenger": "Invita directamente a través del mensajero de tu elección:",
        "mail": "Por correo electrónico",
        "joinTeam": "Únete a nuestro equipo",
        "joinTeam2": "Has sido invitado a la ubicación {location} en la aplicación Octopus Order\n\nCon este enlace puedes unirte directamente a tu equipo.\n\n{inviteLink}\n\nSi este enlace no funciona, puedes unirte a tu equipo en la aplicación con el código\n\n{link}\n\npara unirte a tu nuevo equipo.\n\nPara Android: {appLinkAndroid}\n\nPara IOS: {appLinkIOS}",
        "shareHint": "Por razones de seguridad, el código generado/enviado sólo puede invitar a usuarios básicos. Para obtener una invitación con los derechos seleccionados, utilice la invitación por correo electrónico."
      },
      "management": {
        "members": "Miembros del equipo de {location}",
        "inviteMember": "Invitar a miembros del equipo",
        "addDevice": "Añadir equipo",
        "permissionExplanation": "Visión general de los derechos de nuestros roles:"
      }
    },
    "missingPermission": "Falta permiso: {permission}",
    "missingCartOrderPermission": "Tus permisos en la aplicación no son suficientes. Ponte en contacto con el propietario de tu ubicación para completar un pedido.",
    "permission": {
      "all": "Todos los permisos",
      "locationOrderHistoryRead": "Leer historial de pedidos",
      "locationListRead": "Ver listas",
      "locationListItemRead": "Ver lista de productos",
      "locationListItemCreate": "Crear productos de lista",
      "locationListItemUpdate": "Editar productos de la lista",
      "locationListItemDelete": "Borrar productos de la lista",
      "locationListCreate": "Crear listas",
      "locationListUpdate": "Editar listas",
      "locationListDelete": "Borrar listas",
      "locationCartRead": "Ver cesta de la compra",
      "locationCartAdd": "Rellenar cesta",
      "locationCartUpdate": "Editar productos de la cesta",
      "locationCartDelete": "Borrar productos de la cesta",
      "locationOrderCreate": "Crear pedido",
      "locationOrderRequest": "Ejecutar pedido",
      "locationRead": "Ver ubicación",
      "locationCreate": "Crear ubicación",
      "locationUpdate": "Editar ubicación",
      "locationDelete": "Eliminar ubicación",
      "locationTeamRead": "Ver equipo",
      "locationTeamMemberAdd": "Añadir miembro del equipo",
      "locationTeamMemberDelete": "Eliminar miembro del equipo",
      "locationTeamMemberRoleUpdate": "Editar funciones de los miembros del equipo",
      "locationSupplierRead": "Ver proveedores",
      "locationSupplierCreate": "Añadir proveedores",
      "meRead": "Leer datos del propio usuario",
      "meUpdate": "Editar los datos del usuario",
      "meDelete": "Borrar usuario propio",
      "locationListReminderCreate": "Crear alarma de pedido",
      "locationListReminderDelete": "Borrar alarma de pedido",
      "locationListReminderRead": "Ver alarma de pedido",
      "locationListReminderUpdate": "Editar alarma de pedido",
      "locationContactSupplier": "Contactar con el proveedor",
      "locationChatRead": "Leer el chat",
      "locationChatCreate": "Enviar mensajes"
    },
    "noListEntries": "Actualmente no hay artículos en esta lista",
    "noSearchResults": "No se han encontrado elementos para tu filtro",
    "noEntries": "No hay artículos disponibles",
    "noMail": "Ningún correo recibido",
    "login": {
      "emailSent": "Acabamos de enviarle un correo",
      "setPassword": "Puede establecer una nueva contraseña a través del enlace",
      "resetPassword": "Introduce tu dirección de correo electrónico y recibe una nueva contraseña"
    },
    "start": {
      "notNew": "Ya es cliente",
      "new": "Primera vez aquí"
    },
    "cart": {
      "amount": "{amount} Posiciones de artículos",
      "selectionFrom": "Selección en {deliverer}",
      "fromList": "De tus listas",
      "noList": "Sin lista",
      "lastOrder": "De su último pedido",
      "amountItems": "{amount} Artículo único",
      "upgradeToPromotion": "¡Ya casi está! Sólo {amount} Piezas hasta el {shortTitle} Acción 🏷️ → pedir ahora",
      "convertToPromotion": "Acción asegurada 🏷️ → activar ahora"
    },
    "register": {
      "intro": "Para crear tu perfil necesitamos algunos datos",
      "thank": "Gracias {name}",
      "emailSent": "@:mensajes.login.emailEnviado",
      "validate": "Confirma tu cuenta a través del enlace",
      "validateEmail": "@:{'messages.register.validate'} que se ha enviado a tu dirección de correo electrónico antes de que puedas hacer el pedido",
      "noCode": "No tengo código de invitación",
      "code": "He recibido un código de invitación",
      "skipEmail": "Lamentablemente, no hemos podido encontrar la dirección de correo electrónico que ha introducido. Confirme de nuevo su dirección de correo electrónico."
    },
    "didYouMean": "¿Está buscando {target} por casualidad?",
    "didYouCheck": "¿Ha buscado todos los proveedores en la vista anterior?",
    "agbRequired": "Tienes que aceptar la política de privacidad.",
    "list": {
      "repeatEach1": "Recordatorio",
      "repeatEach2": "Todo",
      "noTags": "No hay categorías de filtro disponibles. Añade categorías a los productos de tu lista.",
      "overrideCartList": "La lista ya está en tu cesta de la compra. ¿Quieres sobrescribir tu cesta de la compra?",
      "overrideProductList": "Este producto ya está en tu cesta. ¿Quieres sobrescribir tu cesta?",
      "noReminder": "Aún no se han creado alarmas de pedido para esta lista.",
      "amountReset": "Se han restablecido las cantidades de productos.",
      "resetCheck": "¿Estás seguro de que quieres poner a 0 todas las cantidades de esta lista?"
    },
    "pressEnter": "Confirme con el teclado para añadir",
    "changedEmail": "Acabamos de enviarte un correo electrónico a la nueva dirección. Para aplicar el cambio, haz clic en el enlace que te hemos enviado.",
    "updateLoading": "Se está instalando la actualización",
    "intro": {
      "home": {
        "msg1": "Haz clic en la cabecera para volver a la vista general de tu ubicación y a tu cesta de la compra",
        "title1": "Llegar a tus ubicaciones y al carrito de la compra",
        "msg2": "Puedes acceder directamente a tus pedidos más recientes y a las listas de pedidos frecuentes a través del panel de control.",
        "title2": "Visión general de tus actividades",
        "msg3": "Utiliza la barra de menús para llegar a tu destino con un solo clic.",
        "title3": "Navegación accesible en todas partes"
      },
      "list": {
        "title1": "El orden empieza aquí",
        "msg1": "Utiliza la cabecera para acceder a tus listas y catálogo. Aquí puedes buscar los artículos de tus proveedores.",
        "title2": "Sus proveedores",
        "msg2": "Aquí puedes ver y editar las listas de pedidos de tus proveedores o crear tú mismo nuevas listas.",
        "title3": "Ordenar y eliminar",
        "msg3": "Toca la imagen del producto para seleccionar uno o varios artículos, moverlos arrastrándolos o eliminarlos con el icono de la papelera.",
        "title4": "Personalice fácilmente la lista",
        "msg4": "La cantidad de un producto se puede modificar con los botones más y menos. Desliza el dedo hacia la derecha para eliminar el producto de la lista.",
        "title5": "Encuentre artículos rápidamente",
        "msg5": "En el catálogo puedes ver y buscar los artículos individuales de tus proveedores y filtrarlos por categoría."
      },
      "promotion": {
        "title1": "Promociones y sugerencias",
        "msg1": "Aquí puedes ver las promociones actuales, sugerencias de productos o noticias de tus proveedores o de Pedido Pulpo.",
        "title2": "Ofertas especiales de tus proveedores",
        "msg2": "Aquí puedes ver los artículos de tus proveedores para los que hay ofertas especiales actualmente disponibles.",
        "title3": "Sugerencias y noticias actuales",
        "msg3": "Las sugerencias de productos te proporcionan información sobre las últimas tendencias en el sector de las bebidas. En la sección de noticias puedes enterarte de las últimas novedades sobre Octopus."
      },
      "setting": {
        "msg1": "Aquí puedes gestionar tus proveedores y ubicaciones, realizar ajustes, ver pedidos o contactar con el servicio de asistencia.",
        "title1": "Configuración de la aplicación",
        "msg2": "Aquí puedes establecer alarmas para recordarte periódicamente que tienes que pedir tu lista.",
        "title2": "No vuelvas a olvidar un pedido",
        "msg3": "Aquí puedes gestionar tu equipo e invitar a otros miembros del equipo a Octopus Order.",
        "title3": "Su propio equipo",
        "msg4": "Aquí tienes una visión general de todos tus proveedores y puedes editarlos o eliminarlos, así como añadir nuevos proveedores.",
        "title4": "Resumen de proveedores"
      }
    },
    "ordering": "Pedido en ejecución",
    "noConnection1": "No hay conexión con el servidor",
    "noConnection2": "Comprueba tu conexión a Internet",
    "switchLocation": "La notificación pertenece a otra ubicación. ¿Desea cambiar de ubicación?",
    "containsExpiredPromotion": "Hay un artículo promocional caducado en su cesta de la compra. Por favor, elimínelo para continuar con su pedido.",
    "addProductsViaScanner": "Añadir productos a través del escáner",
    "scanDesiredProducts": "Escanee los productos que desee",
    "scanToAddMoreProducts": "Escanear para añadir más productos",
    "updateScanItems": "¿Desea añadir los artículos escaneados a su lista? Se sobrescribirá el número de artículos de la lista.",
    "addScanItems": "¿Desea añadir sus artículos escaneados a la cesta de la compra?",
    "holidayDeliveryTitle": "El día de entrega seleccionado es festivo",
    "holidayDelivery": "Consulte con su proveedor la fecha exacta de entrega.",
    "longOrder": "Su pedido es a más de siete días vista. De verdad quieres hacer el pedido en {date}?",
    "cartDataMissing": "Datos de pedido incorrectos",
    "newBinaryVersion": "Una nueva versión está disponible y contiene cambios importantes. Por favor, actualice su versión.",
    "deliveryDayWarningTitle": "La fecha seleccionada no es un día de entrega normal",
    "deliveryDayWarning": "Por favor, aclare con antelación los casos excepcionales con el proveedor.",
    "holidayPickupTitle": "El día de recogida seleccionado es festivo",
    "holidayPickup": "Consulte con su proveedor la fecha exacta de recogida.",
    "modal": {
      "updateLocationTypeTitle": "Tu elección, tu ventaja",
      "updateLocationTypeDescription": "Cuando selecciona su negocio de restauración, personalizamos el contenido y las promociones para usted. Puede cambiar esta configuración en cualquier momento.",
      "updateLocationTypeHint": "La selección solo se utiliza dentro de la app y puede personalizarse en cualquier momento."
    },
    "currentLocation": "Actualmente se encuentra en la ubicación"
  },
  "object": {
    "order": "Pedido | Pedidos",
    "article": "Posición de los artículos",
    "promotion": "Acción | Acciones",
    "location": "Ubicación",
    "cart": "Cesta de la compra",
    "list": "Lista | Listas",
    "filter": "Filtrar",
    "message": "Noticias | Noticias",
    "catalog": "Catálogo",
    "notification": "Notificación | Notificaciones",
    "notificationOption": "@:object.notification{'soptions'}",
    "setting": "Configuración",
    "intro": "Apptour",
    "home": "Inicio",
    "dark": "Oscuridad",
    "light": "Claro",
    "zip": "CÓDIGO POSTAL",
    "city": "Ciudad",
    "street": "Calle",
    "lastname": "Nombre",
    "firstname": "Nombre",
    "address": "Dirección",
    "zipCity": "@objeto:código postal, @objeto:ciudad",
    "profile": "Perfil",
    "pointSystem": "Sistema de puntos",
    "amount": "Cantidad",
    "price": "Precio unitario",
    "total": "Precio total",
    "notAvailable": "Información sobre precios no disponible",
    "sort": "Ordenar",
    "alphabetic": "Alfabético",
    "filterCategory": "@:object.filter{'category'}",
    "priceRange": "Rango de precios",
    "team": "Equipo",
    "deliverer": "Proveedor | Proveedores",
    "display": "Opciones de visualización",
    "statistic": "Estadísticas",
    "imprint": "Pie de imprenta",
    "law": "Aviso legal",
    "support": "Soporte de pedidos Octopus",
    "filterOption": {
      "spirits": "Espíritus",
      "nonAlcoholic": "Bebidas sin alcohol",
      "beer": "Cerveza",
      "gastro": "Necesidades gastro",
      "wine": "Vino",
      "food": "Alimentación",
      "nonFood": "No alimentario",
      "other": "Otros"
    },
    "suggestion": "Producto{sugerencia} | Producto{sugerencia}",
    "news": "Noticias",
    "days": "Días | Día",
    "hours": "Horas | Hora",
    "minutes": "Minutos | Minute",
    "validFor": "Válido para {valor}",
    "validUntil": "Válido hasta el",
    "expired": "Caducado",
    "totalPosition": "Posición total",
    "totalOrder": "Valor total del pedido"
  },
  "enumT": {
    "pinned": "Anclado",
    "new": "Nuevo",
    "restocked": "Disponible de nuevo",
    "reduced": "En oferta",
    "notInStock": "Con plazo de entrega",
    "promotion": "Artículos de promoción",
    "issueType": {
      "bug": "Error",
      "feature": "Característica"
    },
    "contactWay": {
      "none": "No se ponga en contacto con",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "emailOrPhone": "Correo electrónico o teléfono"
    },
    "sortDirection": {
      "asc": "Alfabético ascendente",
      "desc": "Alfabético descendente",
      "catFilter": "Por categoría propia",
      "catSupplier": "Por categoría de proveedor",
      "manually": "Clasificación manual"
    },
    "weekday": {
      "mon": "Lunes",
      "tue": "Martes",
      "wed": "Miércoles",
      "thu": "Jueves",
      "fri": "Viernes",
      "sat": "Sábado",
      "sun": "Domingo"
    },
    "repeatCycle": {
      "once": "único",
      "week": "semanal",
      "month": "mensual",
      "appendix": {
        "week": "semana(s)",
        "month": "mes(es)"
      }
    },
    "month": {
      "january": "Enero",
      "february": "Febrero",
      "march": "Marzo",
      "april": "Abril",
      "may": "Mayo",
      "june": "Junio",
      "july": "Julio",
      "august": "Agosto",
      "september": "Septiembre",
      "october": "Octubre",
      "november": "Noviembre",
      "december": "Diciembre"
    }
  },
  "modal": {
    "selection": "Opciones",
    "addList": "Añadir a la lista",
    "addCart": "Añadir a la cesta",
    "openCatalog": "Abrir en catálogo"
  },
  "success": {
    "addReminder": "Pedido despertador fue añadido",
    "editReminder": "Pedido despertador guardado",
    "deleteReminder": "Pedido despertador borrado",
    "addCart": "El producto ha sido añadido a la cesta de la compra. | El producto ha sido añadido a la cesta de la compra",
    "addPromoPackage": "Paquete promocional fue añadido a la cesta de la compra.",
    "addCartNumber": "{target} Se han añadido artículos individuales de {target2} posiciones de artículo a la cesta de la compra",
    "addList": "El producto ha sido añadido a la lista. | Productos han sido añadidos a la lista.",
    "order": "La lista ha sido ordenada.",
    "save": "{target} se ha guardado correctamente. | {target} se han guardado correctamente.",
    "resendMail": "El email ha sido reenviado.",
    "copyLink": "Enlace copiado",
    "sendLink": "Enlace enviado.",
    "removeProduct": "El producto ha sido eliminado de la cesta de la compra. | El producto ha sido eliminado de la cesta de la compra.",
    "orderFinish": "Se ha creado el pedido.",
    "delete": "{target} ha sido eliminado.",
    "deleteUser": "El usuario ha sido eliminado",
    "deleteMulti": "{amount} {target} han sido eliminados.",
    "send": "{target} ha sido enviado.",
    "create": "{target} ha sido creado.",
    "edit": "{target} ha sido editado con éxito.",
    "add": "Se ha añadido {target}.",
    "deleteTeam": "El usuario ha sido eliminado por el equipo.",
    "setRole": "El rol de usuario se ha establecido correctamente",
    "joinLocation": "La ubicación se ha añadido correctamente",
    "sendInvite": "El email de invitación ha sido enviado.",
    "sendTicket": "Hemos recibido tus comentarios. Muchas Gracias.",
    "aiCall": "El Octobot le llamará en breve."
  },
  "success.": "Campaña realizada con éxito",
  "alert": {
    "delete": {
      "account": "¿Quieres eliminar tu cuenta y todas las ubicaciones asociadas de forma irrevocable?",
      "reminder": "¿Realmente quieres borrar esta alarma de pedido?",
      "location": "¿De verdad quieres borrar esta ubicación?",
      "list": "¿Realmente quieres borrar la lista \"{target}\"?",
      "noList": "¿Desea eliminar todos los productos de su cesta de la compra?",
      "cartSupplier": "¿Quieres vaciar tu cesta de la compra en \"{target}\"?",
      "cartProduct": "¿Realmente desea eliminar el producto \"{target}\" de la cesta de la compra?",
      "cartList": "¿Realmente desea eliminar la lista \"{target}\" y todos los artículos relacionados de la cesta de la compra?",
      "product": "¿Realmente desea eliminar el producto \"{target}\" de la lista? | ¿Desea realmente eliminar los productos seleccionados de la lista?",
      "supplier": "¿Quieres eliminar {name} de tus proveedores? Atención: Al eliminar un proveedor también se eliminarán todas las listas de ese proveedor.",
      "member": "¿Realmente desea eliminar {target}\" del equipo?",
      "tag": "¿Realmente quieres eliminar {target} de tus categorías?",
      "customSupplier": "¿Realmente desea eliminar este proveedor?",
      "scanProduct": "¿Desea eliminar el producto \"{target}\" de sus artículos escaneados?"
    },
    "delivererSuccess": "El proveedor se ha añadido correctamente",
    "delivererError": "Error",
    "delivererSuccessMessage": "Hemos añadido {target} a tu ubicación.",
    "delivererErrorMessage": "no se ha podido añadir {target} a tu ubicación. Por favor, comprueba los datos introducidos.",
    "selectList": "Elija una lista",
    "selectSupplier": "Elija un proveedor",
    "noList": "No hay lista disponible para este proveedor.",
    "noSupplier": "No hay proveedores disponibles para este artículo",
    "discardFormTitle": "Atención",
    "noInternet": "No se han podido sincronizar todos los datos offline. Comprueba tu conexión a Internet.",
    "compatibilityMode": "Has activado el modo de compatibilidad. Mientras esté activado, sólo podrás hacer pedidos a través del portal web. La cantidad que has especificado está ahora en la cesta de la compra. Si quieres hacer el pedido a través de la app, desactiva este modo en los ajustes de la lista.",
    "discardForm": "Tus datos no se guardarán. ¿Abandonar la página de todos modos?",
    "syncing": "Las listas se sincronizan",
    "logout": "¿De verdad quiere darse de baja?",
    "upgradeToPromotion": "¿Utilizar promoción ahora? La cantidad se ajusta automáticamente a la cantidad mínima ({target})",
    "convertToPromotion1": "¿Aplicar acción?",
    "convertToPromotion2": "{target1} Artículo promocional, {target2} normal",
    "orderAmountOverLimit": "Límite alcanzado: {isAmount} Artículo promocional en la cesta de la compra. Máx. +{availableAmount} posible",
    "scannerNotActivated": "La función de escáner no está soportada actualmente por sus proveedores",
    "scannerAvailableOnlyInApp": "La función de escáner sólo está disponible en la aplicación",
    "addLastOrderToCart": "¿Quieres volver a añadir al carrito todos los artículos y las cantidades de tu último pedido?"
  },
  "titleRoute": {
    "locationData": "Crear ubicación",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Seleccionar proveedor",
    "locationAdd": "Añadir ubicación",
    "locationJoin": "Unirse al lugar",
    "addLocationDeliverer": "Añadir proveedor",
    "editLocationDeliverer": "Editar proveedor",
    "settingProfile": "Perfil",
    "settingLocation": "Editar ubicación",
    "settingOrder": "Pedir | Pedidos",
    "settingOrderDetail": "Detalles del pedido",
    "settingTeam": "Equipo",
    "settingTeamInvite": "Invitar equipo",
    "settingDeliverer": "Proveedores",
    "settingDelivererSelect": "Elegir proveedor",
    "settingNotification": "Notificaciones",
    "settingDisplay": "Opciones de visualización",
    "settingSupport": "Soporte",
    "settingLegal": "Aviso legal",
    "cart": "Cesta de la compra",
    "orders": "Pedidos",
    "filter": "Filtrar",
    "addList": "Crear lista",
    "editList": "Editar lista",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Ordenar alarma",
    "changePassword": "Cambiar contraseña",
    "addProduct": "Añadir producto",
    "editProduct": "Editar producto",
    "agb": "Política de privacidad",
    "news": "Noticias Octopus",
    "suggestion": "Propuesta de productos",
    "productDetails": "Detalles del producto",
    "promotionDetails": "Detalles de la acción",
    "productPresentation": "@:titleRuta.productDetalles",
    "promotion": "@:titleRuta.detallesPromoción",
    "settingIntro": "Apptour",
    "feedback": "Crear feedback",
    "scanner": "Escáner",
    "skipEmail": "Verificación del correo electrónico",
    "deleteLocations": "Ubicaciones suprimidas",
    "aiCall": "Orden AI"
  },
  "placeholder": {
    "search": "Buscar en",
    "selectSize": "Seleccionar talla",
    "selectVariant": "Seleccionar variante",
    "location": {
      "name": "Nombre de su ubicación",
      "type": "Tipo de ubicación",
      "zip": "Código postal",
      "ownZip": "Código postal de su localidad",
      "city": "Ciudad",
      "street": "Calle",
      "streetNumber": "No.",
      "phone": "Número de teléfono",
      "internationalPhone": "Número de teléfono internacional",
      "deliverer": "@:seleccionar objeto.repartidor",
      "customerNumber": "@:label.customerNumber introducir"
    },
    "email": "Correo electrónico",
    "newEmail": "Nuevo email",
    "oldPassword": "Antiguo @:input.password",
    "password": "@:entrada.contraseña",
    "passwordRepeat": "@:entrada.contraseña repetir",
    "sendMessageDeliverer": "Enviar un mensaje a {deliverer} ...",
    "inviteCode": "Introduzca el código de invitación",
    "firstName": "@:label.firstName",
    "lastName": "@:label.apellido",
    "name": "Nombre",
    "phone": "@:marcador.lugar.teléfono",
    "street": "Calle",
    "zip": "CÓDIGO POSTAL",
    "city": "Ciudad",
    "alphabetic": "Alfabético",
    "customerNumber": "Número de cliente",
    "customerNumberPlus": "Número de cliente/Número de punto de venta",
    "quickstart": "Código de inicio rápido",
    "paymentMethod": "Forma de pago",
    "pickupMethod": "Ubicación",
    "deliveryDate": "Fecha de entrega",
    "emailOrPhone": "@:placeholder.email",
    "code": "Código de invitación",
    "packaging": "Tamaño del paquete",
    "searchOrAdd": "Buscar o añadir categoría",
    "tagName": "Nombre de la categoría",
    "pickupLocation": "Recoger en",
    "pickupDate": "Hora de recogida",
    "quantity": "Cantidad",
    "eancode": "Código EAN",
    "customSupplierType": "Tipo de proveedor",
    "issueType": "Tipo de respuesta",
    "title": "Título",
    "bug": {
      "issue": "¿Cuál es el problema?",
      "place": "¿Dónde se produce el problema?",
      "expectation": "¿Qué comportamiento esperarías en lugar del actual?",
      "steps": "¿Qué medidas se tomaron hasta que se produjo el fallo? / ¿Cómo se puede reproducir el fallo?"
    },
    "feature": {
      "expectation": "¿Qué función adicional le gustaría ver?",
      "place": "¿Dónde echa en falta la función deseada?"
    },
    "select": "Seleccione",
    "contactWay": "¿Cómo podemos contactar con usted para preguntas y actualizaciones?"
  },
  "option": {
    "industry": {
      "PRIVATE": "Privado",
      "GETRAENKEFACHGROSSHANDEL": "Venta al por mayor de bebidas",
      "LEBENSMITTEL_GROSSHANDEL": "Alimentación al por mayor",
      "HANDELSWAREN_ALLGEMEIN": "Mercancía general",
      "SONSTIGE": "Otros"
    },
    "customSupplierType": {
      "meat": "Proveedor de carne",
      "vegetable": "Verduras",
      "drinks": "Bebidas",
      "hygiene": "Artículos de higiene",
      "other": "Otros"
    }
  }
}

export default es;